import { SmoothScroll } from "@/components/landing/SmoothScroll";
import { Header } from "@/components/landing/Header";
import { MasterclassBanner } from "@/components/landing/MasterclassBanner";
import { Hero } from "@/components/landing/Hero";
import { Ribbon } from "@/components/landing/Ribbon";
import { MiPresento } from "@/components/landing/MiPresento";
import { ImageBand } from "@/components/landing/ImageBand";
import { Percorsi } from "@/components/landing/Percorsi";
import { Servizi } from "@/components/landing/Servizi";
import { Testimonianze } from "@/components/landing/Testimonianze";
import { Faq } from "@/components/landing/Faq";
import { Footer } from "@/components/landing/Footer";
import { WhatsAppFloat } from "@/components/landing/WhatsAppFloat";

export default function Landing() {
  return (
    <div
      className="paper-bg"
      style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/brand/paper-full.jpg)` }}
    >
      <SmoothScroll>
        <Header />
        <main data-testid="main-content">
          <MasterclassBanner />
          <Hero />
          <Ribbon />
          <MiPresento />
          <ImageBand />
          <Percorsi />
          <Servizi />
          <Testimonianze />
          <Faq />
        </main>
        <Footer />
        <WhatsAppFloat />
      </SmoothScroll>
    </div>
  );
}
